export type UsedConceptRoles = Map<string, Set<string | null>>;

export const NO_USED_CONCEPT_ROLES: UsedConceptRoles = new Map();

interface TagLike {
  concept?: { name?: string | null } | null;
  linkroleUri?: string | null;
  metadata?: { unplaced?: boolean } | null;
}

export function buildUsedConceptRoles(tags: TagLike[]): UsedConceptRoles {
  const used: UsedConceptRoles = new Map();
  for (const tag of tags) {
    const name = tag.concept?.name;
    if (!name || tag.metadata?.unplaced) continue;
    const roles = used.get(name) ?? new Set<string | null>();
    roles.add(tag.linkroleUri ?? null);
    used.set(name, roles);
  }
  return used;
}

/**
 * A concept is "used" in a network iff some tag was created under that network's
 * role. Legacy tags (null linkroleUri, pre-GABY-2000) carry no role and count as
 * used in every network — the pre-role-aware behavior.
 */
export function isConceptUsedInRole(used: UsedConceptRoles, conceptName: string, roleURI: string): boolean {
  const roles = used.get(conceptName);
  if (!roles) return false;
  return roles.has(null) || roles.has(roleURI);
}

export function isConceptUsedElsewhere(used: UsedConceptRoles, conceptName: string, roleURI: string): boolean {
  const roles = used.get(conceptName);
  if (!roles) return false;
  return !isConceptUsedInRole(used, conceptName, roleURI);
}
